import gql from 'graphql-tag';
import { store } from 'Models/Store';

export const COUNT_USER_TYPES = gql`
	query countUserTypes {
		countAdminEntitys {
			number
		}
		countInstitutionAdminEntitys {
			number
		}
		countStudentAdvisorEntitys {
			number
		}
		countCurriculumSupportEntitys {
			number
		}
		countUserEntitys {
			number
		}
	}
`;

export const countUserTypes = (abortSignal: AbortSignal) => (
	store.apolloClient
		.query<{
			countAdminEntitys: { number: number },
			countInstitutionAdminEntitys: { number: number },
			countStudentAdvisorEntitys: { number: number },
			countCurriculumSupportEntitys: { number: number },
			countUserEntitys: { number: number },
		}>(
			{
				query: COUNT_USER_TYPES,
				fetchPolicy: 'network-only',
				context: {
					fetchOptions: {
						signal: abortSignal,
					},
				},
			},
		)
);
